<template>

    <div class="ml-5 mr-5"  >

      <b-loading  :active.sync="isFullScreenSearching" ></b-loading>

      <b-field grouped v-if="dataCBCSpecLN"  class="mb-5">

        <b-field label="#"  >
          <h1>Version 3</h1>
        </b-field>



        <b-field label="Request"  v-if="dataCBCSpecLN['info'] " >
          <b-tag  style="background-color: paleturquoise; color: blue" size="is-medium"> {{ dataCBCSpecLN['info'].date_req }}&nbsp;
            <span class="is-size-7" style="color: darkslateblue" >{{  dataCBCSpecLN['info'].time_req }}</span>&nbsp;
            <b-tag rounded>   {{ dataCBCSpecLN['info'].req_by  }}  </b-tag>
          </b-tag>
        </b-field>

        <b-field label="Cancel" v-if="dataCBCSpecLN['info'].date_cancel">
          <b-tag  style="background-color: crimson; color: white" size="is-medium">{{ dataCBCSpecLN['info'].date_cancel }}&nbsp;
            <span class="is-size-7" style="color: white" >{{ dataCBCSpecLN['info'].time_cancel }}</span>&nbsp;
            <b-tag rounded>   {{ dataCBCSpecLN['info'].cancel_by }}  </b-tag>
          </b-tag>
        </b-field>

        <b-field label="Reject" v-if="dataCBCSpecLN['info'].date_reject">
          <b-tag  style="background-color: crimson; color: white" size="is-medium">{{  dataCBCSpecLN['info'].date_reject }}&nbsp;
            <span class="is-size-7" style="color: white" >{{   dataCBCSpecLN['info'].time_reject }}</span>&nbsp;
            <b-tag rounded>   {{  dataCBCSpecLN['info'].reject_by }}  </b-tag>
          </b-tag>
        </b-field>

        <b-field label="Result" v-if="dataCBCSpecLN['info'].date_resulted"  >
          <b-tag  style="background-color: paleturquoise; color: blue" size="is-medium">{{  dataCBCSpecLN['info'].date_resulted }}&nbsp;
            <span class="is-size-7" style="color: darkslateblue" >{{  dataCBCSpecLN['info'].time_resulted }}</span>&nbsp;
            <b-tag rounded>   {{ dataCBCSpecLN['info'].resulted_by }}  </b-tag>
          </b-tag>
        </b-field>


        <b-field label="Last Update" v-if="dataCBCSpecLN['info'].date_resulted_n"  >
          <b-tag  style="background-color: paleturquoise; color: blue" size="is-medium">{{ dataCBCSpecLN['info'].date_resulted_n }}&nbsp;
            <span class="is-size-7" style="color: darkslateblue" >{{  dataCBCSpecLN['info'].time_resulted_n_time }}</span>&nbsp;
            <b-tag rounded>   {{ dataCBCSpecLN['info'].resulted_n_by }}  </b-tag>
          </b-tag>
        </b-field>


        <b-field label="Hold Status" v-if="dataCBCSpecLN['info'].hold"  >
          <b-tag  size="is-medium" type="is-warning is-light">
                    <span class="has-text-info-dark">
                       <b-icon
                           icon="car-brake-hold"
                           size="is-medium">
                    </b-icon>
                    </span>
          </b-tag>
        </b-field>

        <b-field label="#"    >
          <template #label>
            <span class="has-text-white"> # </span>
          </template>
          <b-button  size="is-small"
                     type="is-primary"
                     :disabled ="!userRoleFind(10)"
                     @click="changeStatusCBCLab"
          >{{ dataCBCSpecLN['info'].status ? 'Disable' : 'Enable'}}</b-button>
        </b-field>
<!--        <b-field label="#"  >-->
<!--          <b-button size="is-small" type="is-primary" @click="print">Print</b-button>-->
<!--        </b-field>-->






      </b-field>



      <b-notification
          v-if="dataCBCSpecLN && dataCBCSpecLN.info && !dataCBCSpecLN.info.status"
          type="is-danger"
          :closable="false"
          has-icon
          aria-close-label="Close notification"
          role="alert"
          style="font-size: 40px; "
      >
        ยกเลิก (Disabled Status)
      </b-notification>



      <div   v-if="dataCBCSpecLN && dataCBCSpecLN.info && dataCBCSpecLN.info.status"  >
        <section>
          <!-- วนแต่ละกลุ่ม -->
          <b-collapse
              v-for="(grp, gi) in dataCBCSpecLN.data"
              :key="gi"
              animation="slide"
              :open.sync="grp.isOpen"
              class="card mb-3"
          >
            <!-- header -->
            <div slot="trigger" class="card-header" role="button">
              <p class="card-header-title is-size-6">
                {{ grp.lis_code_grp_mst_name || 'Ungrouped' }}
                <b-tag type="is-info is-light" rounded class="ml-2">{{ grp.data.length }}</b-tag>
              </p>
              <a class="card-header-icon">
                <b-icon icon="menu-down"></b-icon>
              </a>
            </div>

            <!-- content -->
            <div class="card-content">
              <div class="table-container">
                <b-table
                    :data="grp.data"
                    :striped="true"
                    :hoverable="true"
                    :narrowed="true"
                    :mobile-cards="true"
                    :paginated="false"
                >
                  <b-table-column field="code_lis" label="Code" v-slot="props" width="10%">
                    <b-tag type="is-info is-light" size="is-small">{{ props.row.code_lis }}</b-tag>
                  </b-table-column>

                  <b-table-column field="name_lis" label="Parameter" v-slot="props" width="20%">
                    <span class="has-text-weight-medium">{{ props.row.name_lis }}</span>
                    <small v-if="props.row.name_his && props.row.name_his !== props.row.name_lis"
                           class="has-text-grey"> ({{ props.row.name_his }})</small>
                  </b-table-column>

                  <b-table-column label="Result" v-slot="props" width="16%"  >
                      <span class="is-size-6">
                        {{ props.row.val_is_num ? props.row.val : (props.row.val_tx_short || props.row.val) }}
                      </span>
                  </b-table-column>


<!--                  <b-table-column field="unit_name"  label= 'Unit'    v-slot="props" width="8%" centered>-->
<!--                    {{grp.fe_alow_col}}-->
<!--                  <span>{{ props.row.unit_name || '' }}</span>-->
<!--                  </b-table-column>-->

                  <b-table-column field="unit_name" :label="showHeadCol(grp.fe_alow_col, 'Unit')"  v-slot="props" width="8%" centered>
                    <span>{{ props.row.unit_name || '' }}</span>
                  </b-table-column>

                  <b-table-column field="ref_val" :label="showHeadCol(grp.fe_alow_col, 'Reference')" v-slot="props" width="18%">
                      <span class="has-text-grey-dark">
                        {{ props.row.ref_val || '' }}
                      </span>
                  </b-table-column>

                  <b-table-column field="flag"  :label="showHeadCol(grp.fe_alow_col, 'Flag')"  v-slot="props" width="8%">
                    <b-tag v-if="props.row.flag" :type="flagToType(props.row.flag)" rounded>
                      {{ props.row.flag }}
                    </b-tag>
                  </b-table-column>

                  <b-table-column label="Machine" v-slot="props" width="12%">
                    <b-tag v-if="props.row.machine_id" size="is-small" type="is-light">{{ props.row.machine_id }}</b-tag>
                    <span v-else class="has-text-grey">—</span>
                  </b-table-column>

<!--                  <b-table-column label="Note" v-slot="props">-->
<!--                    <b-tooltip-->
<!--                        v-if="showNoteTooltip(props.row)"-->
<!--                        :label="props.row.val_tx_short"-->
<!--                        position="is-top"-->
<!--                        multilined-->
<!--                    >-->
<!--                      <span class="is-truncated">{{ props.row.val_tx_short }}</span>-->
<!--                    </b-tooltip>-->
<!--                    <span v-else class="has-text-grey">—</span>-->
<!--                  </b-table-column>-->
                </b-table>
              </div>
            </div>
          </b-collapse>
        </section>


        <section  v-if="dataCBCSpecLN && dataCBCSpecLN['images'].length>0">
          <p  class="is-size-2 has-text-grey-dark ml-5 subtitle has-text-weight-semibold"> Images</p>

          <div class="columns is-multiline">

            <div class="column is-one-quarter-desktop is-half-tablet"   v-for="img in dataCBCSpecLN['images']" :key="img.id" >


              <div class="card-image" @click="imageModal(img.path)">
                <figure class="image is-4by3"  >
                  <img :src="getURLImgWithUUID( img.path )"  >
                </figure>




              </div>
              <footer class="card-footer">
                <!-- <a class="card-footer-item" @click="imageModal(getURLImgWithUUID( img.path_img ))">
                    <b-icon
                            icon="magnify"
                            size="is-medium">
                    </b-icon>
                </a>

                <a class="card-footer-item" @click="disableImage(img.id)" v-if="modeLabNewsElement==1">
                    <b-icon
                            icon="delete"
                            size="is-medium"
                            type="is-danger"
                            >
                    </b-icon>
                </a> -->


              </footer>





            </div>


          </div>











        </section>



      </div>

      <b-modal :active.sync="isImageModalActive">
        <p class="image ">
          <img :src=dataUrl>
        </p>
      </b-modal>


    </div>
</template>

<script>
import {genUUID, getBaseURLLabCBCImages,getConfigAxios} from "@/utils";
import { mapState } from 'vuex'
import axios from "axios";
import { getBaseURLforBackEnd     } from '@/utils.js'
import userRoleFind from '../../mixins/methods/userRoleFind'




export default {
  name: "CBC_DetailEachID_V3",
  mixins:[userRoleFind,],
  props:{
    dataCBCSpecLN : Object,
  },
  mounted() {
    // console.log("mounted");
  },
  created() {
    // this.$nextTick(()=>{
    //   console.log("created");
    // })

    // เปิดทุก collapse ตั้งแต่เริ่ม
    this.dataCBCSpecLN.data.forEach(g => (g.isOpen = true));

    this.dataCBCSpecLN.data.forEach(grp => {
      grp.data.sort((a, b) => {
        const numA = parseInt(a.code_lis.split('-')[1], 10);
        const numB = parseInt(b.code_lis.split('-')[1], 10);
        return numA - numB;
      });
    });
  },
  computed: {
    ...mapState({
      access_token: state => state.master_data.access_token,
      user_role: state => state.master_data.user_role ,
      CBCWorkList: state => state.worklist.CBCWorkList,
      listoflabopdtarget_v2 : state => state.listoflab_opdtarget.listoflabopdtarget_v2,
    }),
  },
  methods:{

    changeStatusCBCLab(){
      this.isFullScreenSearching = true
      const datTo = {
        "idlab": this.dataCBCSpecLN.info.idlab,
        "enable_status" : !this.dataCBCSpecLN.info.status
      }
      // console.log(JSON.stringify(datTo));
      axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token})}`
      axios.post(`${getBaseURLforBackEnd()}/api/enable_disable_labautomate_by_manual`, datTo , getConfigAxios())
          .then((res)=>{
            this.dataCBCSpecLN.info.status = !this.dataCBCSpecLN.info.status
            // find in
            const tmp1 = this.listoflabopdtarget_v2.find(dat=>dat.idlab == res.data.idlab)
            if(tmp1){
              tmp1.status_cbc_lab = res.data.status
            }
            //  find in
            const tmp2 = this.CBCWorkList.find(dat=>dat.idlab == res.data.idlab)
            if(tmp2){
              tmp2.status_lab_cbc = res.data.status
            }
            this.isFullScreenSearching = false
          })
          .catch((err)=>{
            this.$buefy.toast.open({
              duration: 1000,
              message: `${err.data}`,
              position: 'is-bottom',
              type: 'is-success'
            })
            this.isFullScreenSearching = false
          })
    },


    print(){
      this.isFullScreenSearching = true

      axios.post(`${getBaseURLforBackEnd()}/api/make_report_result_cbc`, this.dataCBCSpecLN, {
        headers: {
          Authorization: `Bearer ${this.access_token}`
        },
        responseType: 'blob' // 🟡 บอก axios ว่าจะรับไฟล์ blob
      })
          .then((res) => {
            // console.log(res);
            const blob = new Blob([res.data], { type: 'application/pdf' })
            const blobURL = window.URL.createObjectURL(blob)
            window.open(blobURL, '_blank', 'location=no,height=570,width=520,scrollbars=yes,status=yes')  // ✅ เปิด PDF ในแท็บใหม่
            this.isFullScreenSearching = false
          })
          .catch((err) => {
            this.isFullScreenSearching = false
            this.$buefy.dialog.alert({
              title: `Error`,
              message: `${err}`,
              confirmText: 'OK!'
            })
          })



      // this.isFullScreenSearching = false
      // axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
      // axios.post(`${getBaseURLforBackEnd()}/api/make_report_result_cbc`,this.dataCBCSpecLN,getConfigAxios())
      //     .then(()=>{
      //       this.isFullScreenSearching = false
      //     })
      //     .catch((err)=>{
      //       this.$buefy.toast.open({
      //         duration: 1000,
      //         message: `${err.data}`,
      //         position: 'is-bottom',
      //         type: 'is-danger'
      //       })
      //       this.isFullScreenSearching = false
      //     })

    },
    getURLImgWithUUID(path){
      return `${getBaseURLLabCBCImages()}${this.dataCBCSpecLN['info'].idlab }/${path}?${genUUID(12)}`
    },
    imageModal(dataUrl){

      if(dataUrl !== "") {
        this.dataUrl = this.getURLImgWithUUID( dataUrl )
        // console.log(this.dataUrl)
      }else{
        this.dataUrl = 'imgnotaval.jpg'
      }
      this.isImageModalActive = true

    },
    showHeadCol(grpfe_alow_col,word) {
      return grpfe_alow_col?.toLowerCase().includes(word.toLowerCase()) ?  word : '';
    },
    flagToType(flag) {
      const f = String(flag || '').toUpperCase();
      if (f === 'N') return '';
      if (f === 'H') return '';
      if (f === 'L') return '';
      return '';

      // const f = String(flag || '').toUpperCase();
      // if (f === 'N') return '';
      // if (f === 'H') return 'is-danger';
      // if (f === 'L') return 'is-danger';
      // return '';


      // const f = String(flag || '').toUpperCase();
      // if (f === 'N') return 'is-success is-light';
      // if (f === 'H') return 'is-danger is-light';
      // if (f === 'L') return 'is-warning is-light';
      // return 'is-info is-light';
    },
    showNoteTooltip(row) {
      return Number(row.val_is_num) === 0 && !!(row.val_tx_short || '').trim();
    }
  },
  data(){
    return {
      isFullScreenSearching : false,

      isImageModalActive : false,
      dataUrl : "",


    }
  }
}
</script>


<style scoped>
.table-container {
  overflow-x: auto;
}
.is-truncated {
  display: inline-block;
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card {
  border-radius: 12px;
  overflow: hidden;
}
.card-header {
  cursor: pointer;
}
img{
  cursor: pointer;
  width:100%;
  height:100%;
  object-fit: contain;

}


</style>